export default __webpack_public_path__ + "c03158a6bd4755e4bc893de595fa23b1.otf";